import React from 'react';
import { Card, CardTitle } from '../styles';

const SyncReport = ({ report }) => {
    if (!report) return null;
    return (
        <Card style={{ marginBottom: '1.5rem', border: `2px solid ${report.failures?.length > 0 ? '#ffbaba' : '#badeba'}` }}>
            <CardTitle>Relatório de Sincronização</CardTitle>
            {report.successes?.length > 0 && (
                <div style={{color: '#2f6f2f'}}>
                    <strong>Sucessos:</strong>
                    <ul style={{listStylePosition: 'inside', paddingLeft: '1rem'}}>{report.successes.map(s => <li key={s.page_name}>Página '{s.page_name}' atualizada com sucesso.</li>)}</ul>
                </div>
            )}
            {report.failures?.length > 0 && (
                <div style={{ marginTop: '1rem', color: '#d8000c' }}>
                    <strong>Falhas:</strong>
                    <ul style={{listStylePosition: 'inside', paddingLeft: '1rem'}}>{report.failures.map((f, i) => <li key={i}>{f}</li>)}</ul>
                </div>
            )}
        </Card>
    );
};

export default SyncReport;